import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from '../auth/auth.module';
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { NotificationModule } from '@progress/kendo-angular-notification';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    DialogsModule,
    AuthModule,
    NotificationModule
  ],
  exports: [HttpClientModule, DialogsModule]
})
export class CoreModule {}
